const FEEDBACK_FORM_BASE =
  "https://docs.google.com/forms/d/e/1FAIpQLSejwxRNOIlqJ7jNSZ8XuIcg-Qx-qO2ueutEU60Bdc9G95UQaA/viewform?usp=pp_url";

export function buildFeedbackUrl({ leagueID = "", userID = "", source = "", role = "" }) {
  return (
    `${FEEDBACK_FORM_BASE}` +
    `&entry.903787091=${encodeURIComponent(leagueID || "")}` +
    `&entry.460917524=${encodeURIComponent(userID || "")}` +
    `&entry.1141384384=${encodeURIComponent(source || "")}` +
    `&entry.235669446=${encodeURIComponent(role || "")}`
  );
}